import { render, staticRenderFns } from "./ConcernElements.vue?vue&type=template&id=2cf8c2f6&"
import script from "./ConcernElements.vue?vue&type=script&lang=js&"
export * from "./ConcernElements.vue?vue&type=script&lang=js&"
import style0 from "./ConcernElements.vue?vue&type=style&index=0&id=2cf8c2f6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports